import React, { useState, useMemo, useEffect, useContext } from 'react'
import ReactMultiSelect from '../../../FormComponents/ReactMultiSelect'
import axiosService from '../../../../utils/AxiosService'
import Input from "../../../FormComponents/Input"
import { Person } from 'react-bootstrap-icons'
import { BrowseContext } from '../../../../contexts/BrowseContext'

export default function NewClientFirstPage({
  setFieldValue,
  handleBlur,
  handleChange,
  values,
  touched,
  errors,
  currentPage,
  setCurrentPage,
 }) {
  const { browseState, clients } = useContext(BrowseContext)
  const [projectManagers, setProjectManagers] = useState([])
  const [selectedCollaborators, setSelectedCollaborators] = useState(values.collaborators)

  const collaboratorIds = useMemo(() => selectedCollaborators.reduce((ids, collaborator) => [...ids, collaborator.id], []), [selectedCollaborators, selectedCollaborators.length])

  const collaboratorOptions = useMemo(() => projectManagers.reduce((options, projectManager) => {
    if (!collaboratorIds.includes(projectManager.id)) options.push({ label: [projectManager.first_name, projectManager.last_name].filter(Boolean).join(" ") || projectManager.email, avatar: projectManager.avatar?.url, value: projectManager.id })
    return options
  }, []), [projectManagers, collaboratorIds, collaboratorIds.length])

  const getProjectManagers = () => {
    axiosService.get('/api/project_manager/project_managers')
      .then(projectManagers => {
        setProjectManagers(projectManagers)
      })
  }

  useEffect(() => getProjectManagers(), [])

  return (
    <div>
      <div>
        <Input
          error={touched.name && errors.name}
          noLabelPadding label="Name"
          placeholder="Client name"
          name="name"
          onChange={handleChange}
          onBlur={handleBlur}
          value={values.name}
        />
      </div>
      <p className='text-md mt-5 font-bold'>Client collaborators</p>
      <div className="flex flex-col gap-4 items-center">
        {
          selectedCollaborators.length !== 0 && (
            <div className='flex w-full mt-5 justify-center'>
              {selectedCollaborators.map(collaborator => (
                <div key={collaborator.id} className="-ml-2">
                  {collaborator?.avatar && <img className="w-9 h-9 rounded-full object-cover" src={collaborator.avatar} alt="avatar" />
                    || <div className="w-9 h-9 bg-rb-green rounded-full text-white flex items-center justify-center border-1 border-white"><Person /></div>}
                </div>
              ))}
            </div>
          )
        }
        <div className='mt-3 mx-auto w-full'>
          <ReactMultiSelect
            placeholder="Select Collaborators"
            inlineDropdown
            name="collaborators"
            options={collaboratorOptions}
            value={selectedCollaborators}
            hasSelectAll={false}
            useSeparator={false}
            onChange={(collaborators) => {
              setFieldValue('collaborators', collaborators)
              setSelectedCollaborators(collaborators)
            }}
          />
        </div>
      </div>


      <div className="flex justify-between mt-5">
        <button
          type='button'
          className='rb-btn-cancel font-bold text-md ml p-2 px-4 rounded-lg'
          onClick={() => browseState.toggleCreateClient()}
        >
          Cancel
        </button>
        <button
          type={currentPage === "secondPage" ? "submit" : "button"}
          className="ml-auto bg-rb-green text-white rounded-lg p-2 px-4 submit text-center active:shadow-outer active:shadow-rb-green border-rb-green"
          onClick={() => setCurrentPage('secondPage')}
        >
          Next
        </button>
      </div>
    </div>
  )
}
